import type { components } from "../types/openapi";

// Modela application/problem+json del contrato (api/contracts/parts/00-base.yaml).
// Ningún componente debe mostrar `detail`/`title` crudos al usuario (SPEC-201
// §4.4, "Ningún mensaje técnico llega a la pantalla"): esos campos son para
// diagnóstico/logs, la UI traduce por `code` o por el estado HTTP.
export type Problem = components["schemas"]["Problem"] & {
  /** Segundos de espera antes de reintentar (Problem de ACCOUNT_LOCKED). */
  retryAfterSeconds?: number;
};

export class ApiError extends Error {
  readonly status: number;
  readonly code: string | undefined;
  readonly problem: Problem | undefined;

  constructor(status: number, problem?: Problem) {
    super(problem?.title ?? `Error HTTP ${String(status)}`);
    this.status = status;
    this.code = problem?.code;
    this.problem = problem;
  }
}
